import React from 'react';
import { CertificationStateProps } from 'models/CertificationStateProps';
import {
  CertificationState as CertificationStateStyled,
  TrustmarkText,
  BuyerProtectionText,
  TrustmarkBuyerprotection,
  CertificateArea,
  CertificationInformationWrapper,
  CertificationTextAndValidity
} from './CertificationState.styles';
import { useIntl } from 'react-intl';
import { TrustmarkImg } from './CertificationState.styles';

const CertificationState = ({
  certificationState
}: CertificationStateProps) => {
  const { formatMessage } = useIntl();

  const validCertificate = (
    <>
      <TrustmarkBuyerprotection>
        <TrustmarkImg />
        <CertificationInformationWrapper>
          <CertificationTextAndValidity>
            <TrustmarkText $isValid>
              {formatMessage({ id: 'CERTIFICATION_STATE.TRUSTMARK' })}
            </TrustmarkText>
            <CertificationStateStyled $isValid>
              {formatMessage({ id: 'CERTIFICATION_STATE.VALID' })}
            </CertificationStateStyled>
          </CertificationTextAndValidity>
          <BuyerProtectionText>
            {formatMessage({ id: 'CERTIFICATION_STATE.BUYERPROTECTION' })}
          </BuyerProtectionText>
        </CertificationInformationWrapper>
      </TrustmarkBuyerprotection>
    </>
  );

  const invalidCertificate = (
    <TrustmarkBuyerprotection>
      <TrustmarkText $isValid={false}>
        {formatMessage({ id: 'CERTIFICATION_STATE.TRUSTMARK' })}
      </TrustmarkText>
      <CertificationStateStyled $isValid={false}>
        {formatMessage({ id: 'CERTIFICATION_STATE.INVALID' })}
      </CertificationStateStyled>
    </TrustmarkBuyerprotection>
  );

  return (
    <CertificateArea $isValid={certificationState}>
      {certificationState ? validCertificate : invalidCertificate}
    </CertificateArea>
  );
};

export default CertificationState;
